import DeleteIcon from "@mui/icons-material/Delete";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import { Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { ingestService } from "../../../Core/Api/services";
import { AclTypes } from "../../../Core/Api/Types/acl-types";
import { UserHasAcl } from "../../../Utils/helpers";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { ModalContext } from "../../Modals";
import ModalConfirmAction, {
  ModalConfirmActionElementProps,
} from "../../Modals/ModalConfirmAction/modal-confirm-action";
import ModalMoveIngestPack, {
  ModalMoveIngestPackElementProps,
} from "../../Modals/ModalMoveIngestPlaceholderToPack/modal-move-ingest-placeholder-to-pack";
import SelectModeBanner from "../SelectModeBanner";

export interface IngestPacksBannerProps {
  handleCloseClick: React.MouseEventHandler;
  onMoveOk?: () => void;
  items: number[];
}

const IngestPacksBanner: React.FC<IngestPacksBannerProps> = (props) => {
  const { t } = useTranslation();
  const { items, onMoveOk, handleCloseClick } = props;
  const customSnackbar = useCustomSnackbar();

  // Modals
  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const handleDelete = () => {
    if (!openModal) return;

    openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
      displayComment: false,
      commentLabel: t("modal:comment.confirmDeletePlaceholder"),
      title: t("modal:title.deletePlaceholders"),
      onConfirm: (comment) => {
        items.forEach((item) => {
          ingestService.DeletePlaceholderById(item).then((response) => {
            if (response.success) {
              customSnackbar(t("alert:success.placeholderDeleted", { item }), "success");
            } else
              customSnackbar(
                t("alert:warning.errorDeletingPlaceholder", { item, message: response.message }),
                "warning"
              );
          });
        });
      },
    });
  };

  const handleMove = () => {
    if (!openModal) return;

    openModal<ModalMoveIngestPackElementProps>(ModalMoveIngestPack, {
      placeholderIds: items,
      onClose: () => {},
      onConfirm: () => {
        onMoveOk && onMoveOk();
      },
    });
  };

  return (
    <SelectModeBanner text={t("banner:body.itemSelected", { count: items.length })} onCloseClick={handleCloseClick}>
      <Button variant="white" startIcon={<MoveDownIcon />} onClick={() => handleMove()}>
        {t("button:moveToAnotherPack")}
      </Button>

      <Button
        variant="contained"
        color="error"
        startIcon={<DeleteIcon />}
        onClick={() => handleDelete()}
        disabled={!UserHasAcl(AclTypes.aclIngestPlaceholderCreate)}
      >
        {t("common:delete")}
      </Button>
    </SelectModeBanner>
  );
};

export default IngestPacksBanner;
